import {
  FETCH_PAGEBYID_REQUEST,
  FETCH_PAGEBYID_SUCCESS,
  FETCH_PAGEBYID_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PAGEBYID_REQUEST:
    case FETCH_PAGEBYID_ERROR:
      return state;

    case FETCH_PAGEBYID_SUCCESS:
      return action.payload;

    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_pagebyid_reducer.js